module.exports = __webpack_public_path__ + "img/logo_shine_digital_couleur_blanc.210bf6d5.png";